module.exports = __webpack_public_path__ + "img/znapshot-ui.7def747b.png";